import React from 'react';

const ModalUbicaciones = ({ material, ubicaciones, resumen, onClose }) => {
  if (!material) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={styles.header}>
          <h2 style={styles.title}>📦 Ubicaciones del Material</h2>
          <button style={styles.btnCerrar} onClick={onClose}>✕</button>
        </div>

        {/* Info del material */}
        <div style={styles.infoMaterial}>
          <div style={styles.infoItem}>
            <span style={styles.label}>Código:</span>
            <strong>{material.codigo}</strong>
          </div>
          <div style={styles.infoItem}>
            <span style={styles.label}>Material:</span>
            <strong>{material.nombre}</strong>
          </div>
        </div>

        {/* Resumen */}
        {resumen && (
          <div style={styles.resumen}>
            <div style={styles.resumenCard}>
              <div style={styles.resumenLabel}>Total</div>
              <div style={styles.resumenValue}>{resumen.total.toFixed(2)}</div>
            </div>
            <div style={styles.resumenCard}>
              <div style={styles.resumenLabel}>Sin Asignar</div>
              <div style={styles.resumenValue}>{resumen.sin_asignar.toFixed(2)}</div>
            </div>
            <div style={styles.resumenCard}>
              <div style={styles.resumenLabel}>Asignado</div>
              <div style={styles.resumenValue}>{resumen.asignado.toFixed(2)}</div>
            </div>
          </div>
        )}

        {/* Tabla de ubicaciones */}
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.tableHeader}>
                <th style={styles.th}>Almacén</th>
                <th style={styles.th}>Proyecto</th>
                <th style={styles.th}>Stock</th>
              </tr>
            </thead>
            <tbody>
              {ubicaciones.length === 0 ? (
                <tr>
                  <td colSpan="3" style={styles.empty}>
                    No hay stock registrado para este material
                  </td>
                </tr>
              ) : (
                ubicaciones.map((u) => (
                  <tr key={u.id} style={styles.tr}>
                    <td style={styles.td}>{u.almacen?.nombre || '—'}</td>
                    <td style={styles.td}>
                      {u.proyecto ? (
                        <span style={styles.proyectoBadge}>
                          🏗️ {u.proyecto.nombre}
                        </span>
                      ) : (
                        <span style={styles.sinAsignar}>Sin asignar</span>
                      )}
                    </td>
                    <td style={styles.tdNum}>
                      <strong>{parseFloat(u.cantidad_disponible).toFixed(2)}</strong>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <button style={styles.btnCerrarFooter} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '12px',
    maxWidth: '700px',
    width: '90%',
    maxHeight: '80vh',
    overflow: 'auto',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
  },
  header: {
    padding: '20px 25px',
    borderBottom: '2px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 1,
  },
  title: {
    margin: 0,
    fontSize: '20px',
    color: '#1e293b',
    fontWeight: '700',
  },
  btnCerrar: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#64748b',
    padding: '5px 10px',
  },
  infoMaterial: {
    padding: '20px 25px',
    backgroundColor: '#f8fafc',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '15px',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  label: {
    fontSize: '12px',
    color: '#64748b',
    fontWeight: '600',
    textTransform: 'uppercase',
  },
  resumen: {
    padding: '20px 25px',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '15px',
  },
  resumenCard: {
    backgroundColor: '#f1f5f9',
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center',
  },
  resumenLabel: {
    fontSize: '12px',
    color: '#64748b',
    marginBottom: '5px',
  },
  resumenValue: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1e293b',
  },
  tableContainer: {
    padding: '0 25px 20px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableHeader: {
    backgroundColor: '#1e293b',
    color: 'white',
  },
  th: {
    padding: '12px',
    textAlign: 'left',
    fontSize: '13px',
    fontWeight: '600',
  },
  tr: {
    borderBottom: '1px solid #e2e8f0',
  },
  td: {
    padding: '12px',
    fontSize: '14px',
    color: '#475569',
  },
  tdNum: {
    padding: '12px',
    fontSize: '14px',
    color: '#1e293b',
    textAlign: 'right',
  },
  empty: {
    padding: '40px',
    textAlign: 'center',
    color: '#94a3b8',
    fontSize: '14px',
  },
  proyectoBadge: {
    backgroundColor: '#dbeafe',
    color: '#1d4ed8',
    padding: '4px 12px',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: '600',
  },
  sinAsignar: {
    color: '#64748b',
    fontSize: '13px',
    fontStyle: 'italic',
  },
  footer: {
    padding: '15px 25px',
    borderTop: '2px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
  },
  btnCerrarFooter: {
    padding: '10px 24px',
    backgroundColor: '#64748b',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default ModalUbicaciones;